import { productDocuments } from "./productDocuments.js";

export const productDocumentArabicBySlug = {
  "decorative-copper-nickel-chrome": {
    title: "أنظمة النحاس والنيكل والكروم الديكورية",
    category: "أنظمة ديكورية",
    badge: "تشطيبات ديكورية",
    description:
      "أنظمة نحاس ونيكل وكروم ديكورية للتشطيبات اللامعة عالية الجودة في السيارات، والهاردوير، والسباكة، والمكونات الصناعية الظاهرة.",
    summary:
      "ملخص لأنظمة ديكورية موجه للمصنعين الذين يحتاجون إلى طبقات نحاس ونيكل وكروم ثابتة وموثوقة. تعرض الوثيقة تقنيات MacDermid Enthone للتطبيقات التي تتطلب مظهرا قويا، ومقاومة للتآكل، وثباتا في الإنتاج.",
    keyFeatures: [
      "يدعم أنظمة الطبقات الديكورية من النحاس والنيكل والكروم.",
      "مصمم لجودة مظهر عالية ومتطلبات صناعية دقيقة.",
      "يناسب أجزاء السيارات، وهاردوير المباني، وأدوات السباكة، والإضاءة، والعدد اليدوية، والأجزاء الظاهرة المشابهة.",
      "يربط بين المظهر الديكوري وثبات العملية وأداء مقاومة التآكل.",
    ],
    applications: ["زخارف السيارات", "خلاطات وتجهيزات السباكة", "هاردوير المباني", "الإضاءة والعدد اليدوية"],
    imageAlt: "عينات معدنية مطلية بتشطيب لامع وديكوري",
  },
  "ankor-wetter-lf-1000": {
    title: "ANKOR WETTER LF 1000",
    category: "أنظمة ديكورية",
    badge: "عامل ترطيب خال من PFAS",
    description:
      "عامل ترطيب خال من PFAS لطلاء الكروم سداسي التكافؤ الديكوري، يعمل كمخفض للرذاذ والتوتر السطحي لتطبيقات المعادن والطلاء على البلاستيك.",
    summary:
      "يقدم ANKOR WETTER LF 1000 كعامل ترطيب مستدام لخطوط الكروم الديكوري التي تحتاج إلى ضبط التوتر السطحي بدون مواد ترطيب تحتوي على PFAS. يساعد العمليات على التحديث مع الحفاظ على قابلية تطبيق مسارات الكروم الديكورية الحالية.",
    keyFeatures: [
      "تقنية ترطيب خالية من PFAS لطلاء الكروم سداسي التكافؤ الديكوري.",
      "يجمع بين خفض الرذاذ وتقليل التوتر السطحي.",
      "يدعم تطبيقات المعادن والطلاء على البلاستيك.",
      "مصمم لتقليل تعقيد الانتقال في عمليات الكروم القائمة.",
    ],
    applications: ["طلاء كروم ديكوري", "الطلاء على البلاستيك", "خفض الرذاذ", "ضبط التوتر السطحي"],
    imageAlt: "مكونات مطلية بالكروم الديكوري بتشطيب عاكس لامع",
  },
  "ankor-hydraulics": {
    title: "ANKOR Hydraulics للأنظمة الهيدروليكية",
    category: "مقاومة البري",
    badge: "عملية كروم صلب",
    description:
      "عملية كروم صلب سريعة لقضبان الهيدروليك، تجمع بين تكلفة تشغيل منخفضة وترسيبات مقاومة للتآكل للتطبيقات الهيدروليكية الصعبة.",
    summary:
      "يركز ANKOR Hydraulics على ترسيبات الكروم الصلب لقضبان الهيدروليك حيث تكون مقاومة التآكل، والإنتاجية، وتكلفة التشغيل عوامل مهمة. صمم لاحتياجات صناعة الهيدروليك وخطوط الإنتاج التي تتطلب أداء موثوقا للقضبان.",
    keyFeatures: [
      "عملية كروم صلب سريعة لقضبان الهيدروليك.",
      "يدعم ترسيبات كروم صلب مقاومة للتآكل.",
      "مصمم لتكلفة تشغيل منخفضة وإنتاجية قوية.",
      "يستخدم تقنية منخفضة الرغوة لدعم التشغيل العملي للخط.",
    ],
    applications: ["قضبان هيدروليك", "طلاء كروم صلب", "أسطح مقاومة للبري", "مكونات حركة صناعية"],
    imageAlt: "تفصيلة لقضيب هيدروليك ومكون صناعي مطلي بالكروم الصلب",
  },
  "alumal-bond-703": {
    title: "ALUMAL BOND 703",
    category: "تجهيز الأسطح والمعادن الخفيفة",
    badge: "طبقة تحويل خالية من الكروم",
    description:
      "طبقة تحويل خالية من الكروم للألومنيوم تدعم الالتصاق وأداء مقاومة التآكل أسفل طبقات البودرة أو الدهان أو الورنيش.",
    summary:
      "ALUMAL BOND 703 طبقة تحويل للألومنيوم تعتمد على نهج خال من الكروم. وهي مخصصة لمسارات تشطيب الألومنيوم التي تحتاج إلى التصاق وأداء مقاومة للتآكل قبل طبقات التشطيب العضوية.",
    keyFeatures: [
      "طبقة تحويل خالية من الكروم للألومنيوم.",
      "تحسن الالتصاق قبل البودرة أو الدهان أو الورنيش.",
      "تعتمد على نظام بوليمر وزركونيوم/تيتانيوم.",
      "تدعم أداء مقاومة التآكل أسفل طبقات التشطيب في المعادن الخفيفة.",
    ],
    applications: ["تشطيب الألومنيوم", "معالجة قبل البودرة", "معالجة قبل الدهان", "التصاق الورنيش"],
    imageAlt: "أجزاء ألومنيوم وصورة لمعالجة أسطح المعادن الخفيفة",
  },
  "additive-tr-101": {
    title: "ADDITIVE TR 101",
    category: "إعادة تدوير البلاستيك",
    badge: "إضافة من عبوة إلى عبوة",
    description:
      "إضافة منظف مائية لمرحلة الغسيل في عمليات إعادة التدوير الميكانيكي لعبوات PET المشكلة حراريا.",
    summary:
      "يدعم ADDITIVE TR 101 مسارات إعادة التدوير من عبوة إلى عبوة من خلال تحسين مرحلة الغسيل للتغليف المشكل حراريا. صمم للعمل عند درجات حرارة أقل ودعم فصل الطبقات أثناء إعادة التدوير الميكانيكي لـ PET.",
    keyFeatures: [
      "إضافة منظف مائية لإعادة تدوير العبوات المشكلة حراريا.",
      "تدعم الغسيل أثناء إعادة التدوير الميكانيكي لـ PET.",
      "درجة تشغيل منخفضة تساعد على تجنب تبلور PET.",
      "مصممة لتحسين فصل طبقات البولي أوليفين.",
    ],
    applications: ["إعادة تدوير صواني PET", "التغليف المشكل حراريا", "أنظمة الغسيل الساخن", "إعادة التدوير الميكانيكي للبلاستيك"],
    imageAlt: "عملية إعادة تدوير البلاستيك ومواد PET مغسولة",
  },
  "enova-950": {
    title: "ENOVA 950",
    category: "النيكل الكيميائي",
    badge: "نيكل كيميائي عالي الفوسفور",
    description:
      "نظام نيكل كيميائي شبه لامع عالي الفوسفور ومنخفض الإجهاد، بمعدلات ترسيب عالية ومقاومة للتآكل.",
    summary:
      "ENOVA 950 نظام نيكل كيميائي عالي الفوسفور للتطبيقات التي تحتاج إلى مقاومة تآكل، وإجهاد منخفض، وسرعة إنتاج. يناسب العملاء الباحثين عن أداء نيكل كيميائي شبه لامع مع سلوك حوض قوي.",
    keyFeatures: [
      "نظام نيكل كيميائي شبه لامع عالي الفوسفور.",
      "معدلات ترسيب عالية للتشغيل الإنتاجي.",
      "مقاومة ممتازة للتآكل.",
      "ترسيب منخفض الإجهاد للمكونات الصعبة.",
    ],
    applications: ["طلاء النيكل الكيميائي", "مكونات مقاومة للتآكل", "ترسيبات منخفضة الإجهاد", "تشطيب معادن صناعي"],
    imageAlt: "مكونات صناعية مطلية بالنيكل الكيميائي",
  },
  "enova-ef-509": {
    title: "ENOVA EF 509",
    category: "النيكل الكيميائي",
    badge: "نيكل كيميائي منخفض الإجهاد",
    description:
      "عملية نيكل كيميائي شبه لامعة منخفضة الإجهاد وخالية من الرصاص والكادميوم، بعمر محلول طويل وثبات في الحوض.",
    summary:
      "ENOVA EF 509 موجهة لخطوط النيكل الكيميائي التي تحتاج إلى ترسيبات شبه لامعة مستقرة ومنخفضة الإجهاد. تبرز الوثيقة العناية بالكيمياء وثبات الحوض وموثوقية أداء الترسيب.",
    keyFeatures: [
      "عملية نيكل كيميائي خالية من الرصاص والكادميوم.",
      "ترسيبات شبه لامعة منخفضة الإجهاد.",
      "عمر محلول طويل وثبات في الحوض.",
      "تدعم ترسيبا خاليا من الفقاعات وتحكما موثوقا في الإنتاج.",
    ],
    applications: ["ترسيبات نيكل كيميائي شبه لامعة", "طلاء منخفض الإجهاد", "أحواض نيكل كيميائي مستقرة", "حماية وظيفية من التآكل"],
    imageAlt: "مكونات تشطيب نيكل كيميائي شبه لامعة",
  },
  "envirozin-240": {
    title: "Envirozin 240",
    category: "زنك مقاوم للتآكل",
    badge: "زنك قلوي",
    description:
      "عملية زنك قلوية خالية من السيانيد تنتج ترسيبات لامعة ومتجانسة عبر نطاق واسع من كثافات التيار.",
    summary:
      "Envirozin 240 عملية طلاء زنك لترسيبات لامعة ومتجانسة يمكن دمجها مع تمريرات ثلاثية التكافؤ. تدعم العملاء الذين يحتاجون إلى حماية من التآكل وثبات ديكوري في الطلاءات القائمة على الزنك.",
    keyFeatures: [
      "ترسيبات لامعة ومتجانسة عبر نطاق واسع من كثافات التيار.",
      "متوافقة مع تمريرات الزنك الثلاثية الزرقاء والقزحية والصفراء والسوداء.",
      "التصاق ممتاز بالمعدن الأساسي.",
      "مصممة لمتطلبات الطلاء بالزنك المقاوم للتآكل.",
    ],
    applications: ["طلاء زنك قلوي", "مثبتات وهاردوير", "أنظمة تمرير ثلاثية", "الحماية من التآكل"],
    imageAlt: "مثبتات صناعية مطلية بالزنك وتشطيب مقاوم للتآكل",
  },
  "plastic-recycling-brochure": {
    title: "إضافات إعادة تدوير البلاستيك",
    category: "إعادة تدوير البلاستيك",
    badge: "مجموعة إعادة تدوير PET",
    description:
      "نظرة عامة على إضافات إعادة تدوير PET، تشمل المنظفات، وإضافات الفصل، ومضادات الرغوة، ودعم إعادة التدوير الميكانيكي.",
    summary:
      "يعرض كتيب إعادة تدوير البلاستيك مجموعة كاملة من الإضافات لإعادة التدوير الميكانيكي لـ PET. ويغطي منظفات الغسيل الساخن، ودعم فصل البلاستيك، ومضادات الرغوة، وتركيبات لتقنيات إعادة تدوير متنوعة.",
    keyFeatures: [
      "منظفات موجهة للصناعة لعمليات الغسيل الساخن لـ PET.",
      "إضافات متخصصة لفصل البلاستيك.",
      "مضادات رغوة لضبط عمليات إعادة التدوير.",
      "تركيبات لعدة تقنيات إعادة تدوير ميكانيكية.",
    ],
    applications: ["إعادة تدوير PET", "أنظمة الغسيل الساخن", "فصل البلاستيك", "عمليات إعادة التدوير الميكانيكي"],
    imageAlt: "مواد PET لإعادة التدوير وصورة لعملية دائرية",
  },
  "prelik-1700": {
    title: "PRELIK 1700",
    category: "تجهيز الأسطح والمعادن الخفيفة",
    badge: "منظف بدرجة حرارة أقل",
    description:
      "منتج تجهيز أسطح متقدم مصمم لمنظفات كهربائية تعمل بدرجة حرارة أقل وتكاليف تسخين أقل.",
    summary:
      "PRELIK 1700 نظام حديث لتجهيز الأسطح للعمليات التي ترغب في خفض درجة حرارة المنظف واستهلاك الطاقة. صمم لاستخدامات التنظيف الكهربائي والتنظيف بالغمر.",
    keyFeatures: [
      "مصمم للتنظيف الكهربائي بدرجة حرارة أقل.",
      "يمكن أن يساعد في خفض تكاليف طاقة التسخين.",
      "يعمل كمنظف كهربائي ومنظف بالغمر.",
      "يدعم تجهيز السطح قبل عمليات التشطيب.",
    ],
    applications: ["تنظيف كهربائي", "تنظيف بالغمر", "معالجة أولية موفرة للطاقة", "تجهيز الأسطح"],
    imageAlt: "خط تجهيز أسطح وعملية تنظيف صناعية",
  },
  "iridite-tcp-system": {
    title: "نظام Iridite TCP",
    category: "تجهيز الأسطح والمعادن الخفيفة",
    badge: "طبقة تحويل",
    description:
      "نظام طبقة تحويل Iridite TCP بمقاومة قوية للتآكل، وتوافق مع اللواصق والدهان، وخيارات عملية مرنة.",
    summary:
      "Iridite TCP نظام تشطيب للمعادن الخفيفة يركز على مقاومة التآكل والتوافق مع طبقات الطلاء اللاحقة. تبرز الوثيقة مرونة العملية في صيغة مكون واحد أو مكونين.",
    keyFeatures: [
      "مقاومة تآكل عالية وفق اختبارات رش الملح المعروفة.",
      "توافق قوي مع اللواصق والدهان.",
      "متاح بصيغ عملية مرنة من مكون واحد أو مكونين.",
      "مناسب لمسارات طبقات التحويل على الألومنيوم.",
    ],
    applications: ["طبقة تحويل للألومنيوم", "التصاق الدهان", "الربط بالمواد اللاصقة", "معالجة أولية مقاومة للتآكل"],
    imageAlt: "طبقة تحويل للمعادن الخفيفة وسطح ألومنيوم معالج",
  },
  "cuprostar-1600-1610": {
    title: "CUPROSTAR 1600 و1610",
    category: "أنظمة ديكورية",
    badge: "نحاس حمضي لامع",
    description:
      "حلول طلاء نحاس حمضي لامع مثبتة إنتاجيا تنتج طبقات مطيلة مع أداء تسوية قابل للضبط.",
    summary:
      "CUPROSTAR 1600 و1610 أنظمة نحاس حمضي لامع تستخدم كطبقات وسيطة في تسلسلات النيكل والكروم. وهي مخصصة للأنظمة الديكورية التي تحتاج إلى ترسيبات نحاس لامعة ومطيلة.",
    keyFeatures: [
      "حلول طلاء نحاس حمضي لامع.",
      "تنتج طبقات نحاس حمضية مطيلة.",
      "أداء تسوية متغير للتشطيب الديكوري.",
      "تدعم أنظمة طبقات النيكل والكروم.",
    ],
    applications: ["نحاس حمضي لامع", "أنظمة نيكل-كروم ديكورية", "طبقات نحاس وسيطة", "تسوية قبل التشطيب النهائي"],
    imageAlt: "طلاء نحاس حمضي لامع وتشطيب معدني ديكوري",
  },
  castelox: {
    title: "CASTELOX",
    category: "تجهيز الأسطح والمعادن الخفيفة",
    badge: "دعم الأنودة",
    description:
      "تقنية لأنودة مسبوكات الألومنيوم عالية السيليكون، تحسن المظهر والكفاءة من خلال معالجة عيوب السطح.",
    summary:
      "CASTELOX نظام لأنودة مسبوكات الألومنيوم عالية السيليكون حيث قد تتأثر الجمالية وكفاءة العملية بظروف سطح المسبوكات. يستهدف عيوب السطح المرتبطة بالمناطق الغنية بالسيليكون.",
    keyFeatures: [
      "يدعم أنودة مسبوكات الألومنيوم عالية السيليكون.",
      "يعالج عيوب السطح الناتجة عن مناطق غنية بالسيليكون.",
      "يحسن مظهر الأكسيد وثباته.",
      "مصمم لتحسين الجمالية وكفاءة العملية.",
    ],
    applications: ["مسبوكات ألومنيوم", "أنظمة أنودة", "مكونات عالية السيليكون", "تشطيبات جمالية للمعادن الخفيفة"],
    imageAlt: "مسبوك ألومنيوم مؤكسد وتشطيب معدن خفيف",
  },
  "niklad-eco-mp": {
    title: "NiKlad Eco MP",
    category: "النيكل الكيميائي",
    badge: "نيكل كيميائي متوسط الفوسفور منخفض المعدن",
    description:
      "عملية نيكل كيميائي متوسطة الفوسفور ومنخفضة المعدن، مصممة كخيار خال من الرصاص والكادميوم مع سحب محلول أقل.",
    summary:
      "NiKlad Eco MP عملية نيكل كيميائي منخفضة المعدن ومتوسطة الفوسفور للعملاء الباحثين عن حوض نيكل كيميائي أكثر كفاءة. تبرز الوثيقة العناية بالكيمياء وخفض سحب المحلول.",
    keyFeatures: [
      "عملية نيكل كيميائي متوسطة الفوسفور ومنخفضة المعدن.",
      "كيمياء خالية من الرصاص والكادميوم.",
      "سحب أقل لمحلول العملية إلى الشطف.",
      "يدعم تشغيل الحوض بكفاءة وترسيبات نيكل كيميائي لامعة.",
    ],
    applications: ["نيكل كيميائي متوسط الفوسفور", "تشغيل حوض منخفض المعدن", "برامج نيكل كيميائي خالية من الرصاص", "تشطيب نيكل وظيفي"],
    imageAlt: "عملية نيكل كيميائي وسطح صناعي مطلي",
  },
  "evolve-chrome-free-etch": {
    title: "evolve للحفر الخالي من الكروم",
    category: "تجهيز الأسطح والمعادن الخفيفة",
    badge: "عملية POP خالية من Cr(VI)",
    description:
      "عملية متوافقة بيئيا وخالية من Cr(VI) للطلاء على البلاستيك، مصممة كبديل خال من PFOS/PFAS وقابل للتكيف.",
    summary:
      "تعرض evolve وevolve BOND كتقنيات عملية خالية من الكروم للطلاء على البلاستيك. تركز الوثيقة على الامتثال، وقابلية التكيف، والانتقال بعيدا عن الكروم سداسي التكافؤ والكيميائيات المحتوية على PFAS.",
    keyFeatures: [
      "عملية خالية من Cr(VI) للطلاء على البلاستيك.",
      "نهج خال من PFOS/PFAS.",
      "تموضع مرن وقابل للتكيف للعملية.",
      "يدعم معالجة أولية متوافقة بيئيا للطلاء على البلاستيك.",
    ],
    applications: ["الطلاء على البلاستيك", "حفر خال من الكروم", "معالجة POP أولية", "معدنة البلاستيك الديكورية"],
    imageAlt: "عملية طلاء على البلاستيك وتقنية حفر خالية من الكروم",
  },
  "eplating-case-study": {
    title: "دراسة حالة ePlating وهندسة الأسطح",
    category: "زنك مقاوم للتآكل",
    badge: "اعتماد ZinKlad",
    description:
      "دراسة حالة عن تسريع نمو ePlating and Surface Engineering من خلال اعتماد ZinKlad ومعالجات الأسطح عالية الأداء.",
    summary:
      "توضح هذه الدراسة كيف دعم اعتماد ZinKlad شركة ePlating and Surface Engineering في توسيع قدراتها في معالجات الأسطح عالية الأداء لعملاء السيارات والهندسة الذين لديهم متطلبات عالية.",
    keyFeatures: [
      "قصة عميل تركز على اعتماد ZinKlad.",
      "تربط الاعتماد بالنمو والمصداقية السوقية.",
      "تبرز القدرة على معالجات الأسطح عالية الأداء.",
      "مهمة للمطبقين الذين يخدمون أسواق السيارات والهندسة.",
    ],
    applications: ["اعتماد ZinKlad", "تشطيب السيارات", "طلاءات هندسية", "استراتيجية نمو للمطبقين"],
    imageAlt: "منشأة إنتاج لهندسة الأسطح وصورة دراسة حالة",
  },
  "zinklad-2024": {
    title: "نشرات ZinKlad 2024",
    category: "زنك مقاوم للتآكل",
    badge: "مجموعة طلاءات الزنك",
    description:
      "مجموعة نشرات لأنظمة ZinKlad القائمة على الزنك، تشمل تشطيبات شبيهة بالكروم الديكوري وأداء مقاوم للتآكل.",
    summary:
      "تلخص نشرات ZinKlad عائلة من أنظمة الطلاء التضحية القائمة على الزنك. وتغطي المظهر الشبيه بالكروم الديكوري، وقواعد الطلاء العضوي، وأنظمة التمرير، وتموضع أداء مقاومة التآكل.",
    keyFeatures: [
      "مجموعة طلاءات تضحية قائمة على الزنك.",
      "تدعم تشطيبات ديكورية ووظيفية مقاومة للتآكل.",
      "تشمل تموضع أنظمة التمرير والطلاء.",
      "مناسبة للأجزاء التي تحتاج إلى أداء زنك متين.",
    ],
    applications: ["طلاءات الزنك", "هاردوير السيارات", "تشطيبات ديكورية مقاومة للتآكل", "قواعد طلاء عضوية"],
    imageAlt: "نظام طلاء زنك ZinKlad وتشطيب مقاوم للتآكل",
  },
  "wear-resistant-coatings": {
    title: "الطلاءات المقاومة للبري",
    category: "مقاومة البري",
    badge: "تقنيات مقاومة البري",
    description:
      "نظرة عامة على تقنيات مقاومة البري، مع إبراز النيكل الكيميائي للتطبيقات الصعبة التي تتطلب مقاومة للبري والتآكل.",
    summary:
      "تشرح نظرة الطلاءات المقاومة للبري كيف يستخدم النيكل الكيميائي وتقنيات الطلاء المرتبطة عندما يحتاج المهندسون إلى مقاومة قوية للبري والتآكل على مكونات عالية المتطلبات.",
    keyFeatures: [
      "نظرة عامة على تقنيات مقاومة البري.",
      "تضع النيكل الكيميائي ضمن التطبيقات الصعبة.",
      "تربط مقاومة البري بأداء مقاومة التآكل.",
      "مفيدة لاختيار الطلاء في التطبيقات الهندسية.",
    ],
    applications: ["مكونات مقاومة للبري", "نيكل كيميائي", "طلاءات هندسية", "التحكم في التآكل والبري"],
    imageAlt: "جزء صناعي مطلي لمقاومة البري وصورة تقنية أداء",
  },
  watercare: {
    title: "WaterCARE",
    category: "معالجة المياه",
    badge: "معالجة مياه الصرف",
    description:
      "مجموعة كيميائيات استشارية لمعالجة مياه الصرف، مصممة حسب احتياجات كل نظام وظروف التشغيل.",
    summary:
      "يركز WaterCARE على كيميائيات معالجة مياه صرف مخصصة. وهو موجه للمنشآت التي تحتاج إلى برامج معالجة مصممة حسب النظام، وظروف التشغيل، والمسؤوليات البيئية.",
    keyFeatures: [
      "كيميائيات معالجة مياه صرف مخصصة.",
      "نهج استشاري حسب احتياجات كل نظام.",
      "يدعم متطلبات التشغيل وأداء المعالجة.",
      "مصمم لإدارة مسؤولة لموارد المياه.",
    ],
    applications: ["معالجة مياه الصرف", "صرف تشطيب المعادن", "إدارة موارد المياه", "كيمياء معالجة مخصصة"],
    imageAlt: "دعم معالجة المياه وكيمياء مياه الصرف",
  },
};

export const productDocumentExtraArabicText = {
  "Product Pages": "صفحات المنتجات",
  "Product pages": "صفحات المنتجات",
  "Browse Product Pages": "تصفح صفحات المنتجات",
  "Focused product pages for industrial surface-finishing chemistry, additives, process support, and specialty applications.":
    "صفحات منتجات مركزة لكيمياء تشطيب الأسطح الصناعية والإضافات ودعم العمليات والتطبيقات المتخصصة.",
  "Explore product pages built from supplied brochures, factsheets, and case studies.":
    "استعرض صفحات منتجات مبنية من الكتيبات والنشرات ودراسات الحالة المقدمة.",
  "Wear Resistant Coatings": "الطلاءات المقاومة للبري",
  "Electroless nickel and coating technologies for wear control.":
    "تقنيات النيكل الكيميائي والطلاءات للتحكم في البري.",
  "Browse focused product pages built from the latest supplied product brochures, factsheets, and case studies.":
    "استعرض صفحات منتجات مركزة مبنية من أحدث كتيبات المنتجات والنشرات ودراسات الحالة المقدمة.",
  "Focused product pages built from supplied product brochures, factsheets, and case studies.":
    "صفحات منتجات مركزة مبنية من كتيبات المنتجات والنشرات ودراسات الحالة المقدمة.",
  "Explore Solutions": "استعرض الحلول",
  "Overview": "نظرة عامة",
  "Document type": "نوع الوثيقة",
  "Key features": "الخصائص الرئيسية",
  "What it supports": "ما الذي يدعمه",
  "Applications": "التطبيقات",
  "Where it fits": "مجالات الاستخدام",
  "Related documents": "وثائق ذات صلة",
  "Ask about product availability": "اسأل عن توافر المنتج",
  "Product Documents": "وثائق المنتجات",
  "Product document image": "صورة وثيقة المنتج",
  "Additional document images": "صور إضافية للوثيقة",
  "Solutions product documents": "وثائق منتجات الحلول",
  "Related product documents": "وثائق منتجات ذات صلة",
  "Light metals": "المعادن الخفيفة",
  "Surface preparation": "تجهيز الأسطح",
  "Case study": "دراسة حالة",
  "ePlating Case Study": "دراسة حالة ePlating",
  "Layered copper, nickel, and chrome systems for bright decorative finishes.":
    "أنظمة طبقات من النحاس والنيكل والكروم لتشطيبات ديكورية لامعة.",
  "PFAS-free wetter for decorative hexavalent chromium plating.": "عامل ترطيب خال من PFAS لطلاء الكروم الديكوري سداسي التكافؤ.",
  "Rapid hard chrome process for hydraulic rods and demanding components.":
    "عملية كروم صلب سريعة لقضبان الهيدروليك والمكونات عالية المتطلبات.",
  "Cr-free aluminum conversion coating for adhesion and corrosion support.":
    "طبقة تحويل ألومنيوم خالية من الكروم لدعم الالتصاق ومقاومة التآكل.",
  "Water-based detergent additive for thermoformed PET recycling wash steps.":
    "إضافة منظف مائية لخطوات غسل إعادة تدوير PET المشكل حراريا.",
  "Semi-bright high phosphorus electroless nickel with low-stress performance.":
    "نيكل كيميائي شبه لامع عالي الفوسفور بأداء منخفض الإجهاد.",
  "Lead- and cadmium-free reduced-stress semi-bright EN process.":
    "عملية نيكل كيميائي شبه لامعة منخفضة الإجهاد وخالية من الرصاص والكادميوم.",
  "Alkaline non-cyanide zinc process for uniform bright deposits.":
    "عملية زنك قلوية خالية من السيانيد لترسيبات لامعة ومتجانسة.",
  "Detergents, separation additives, and anti-foaming support for PET recycling.":
    "منظفات وإضافات فصل ودعم مضاد للرغوة لإعادة تدوير PET.",
  "Lower-temperature surface preparation cleaner for energy-conscious lines.":
    "منظف تجهيز أسطح بدرجة حرارة أقل للخطوط التي تراعي استهلاك الطاقة.",
  "Conversion coating system for corrosion resistance and paint compatibility.":
    "نظام طبقة تحويل لمقاومة التآكل والتوافق مع الدهان.",
  "Bright acid copper layers for decorative nickel-chrome sequences.":
    "طبقات نحاس حمضي لامعة لتسلسلات النيكل والكروم الديكورية.",
  "Anodizing support for high-silicon aluminum castings.":
    "دعم الأنودة لمسبوكات الألومنيوم عالية السيليكون.",
  "Lead- and cadmium-free low-metal medium phosphorus EN process.":
    "عملية نيكل كيميائي متوسطة الفوسفور منخفضة المعدن وخالية من الرصاص والكادميوم.",
  "Cr(VI)-free and PFOS/PFAS-free process for plating on plastics.":
    "عملية خالية من Cr(VI) وPFOS/PFAS للطلاء على البلاستيك.",
  "ZinKlad certification case study for surface engineering growth.":
    "دراسة حالة عن اعتماد ZinKlad ونمو هندسة الأسطح.",
  "Zinc-based sacrificial coating systems for corrosion-resistant finishes.":
    "أنظمة طلاء تضحية قائمة على الزنك لتشطيبات مقاومة للتآكل.",
  "Overview of electroless nickel and coating technologies for wear control.":
    "نظرة عامة على النيكل الكيميائي وتقنيات الطلاء للتحكم في البري.",
  "Customized wastewater treatment chemistry for metal-finishing operations.":
    "كيميائيات مخصصة لمعالجة مياه الصرف لعمليات تشطيب المعادن.",
};

export const productDocumentArabicText = productDocuments.reduce((acc, doc) => {
  const ar = productDocumentArabicBySlug[doc.slug];
  if (!ar) return acc;
  acc[doc.title] = ar.title;
  acc[doc.category] = ar.category;
  acc[doc.badge] = ar.badge;
  acc[doc.description] = ar.description;
  acc[doc.summary] = ar.summary;
  doc.keyFeatures.forEach((feature, index) => {
    acc[feature] = ar.keyFeatures[index] || feature;
  });
  doc.applications.forEach((application, index) => {
    acc[application] = ar.applications[index] || application;
  });
  return acc;
}, { ...productDocumentExtraArabicText });

export const productDocumentArabicAttributes = productDocuments.reduce(
  (acc, doc) => {
    const ar = productDocumentArabicBySlug[doc.slug];
    if (ar?.imageAlt) acc[doc.imageAlt] = ar.imageAlt;
    return acc;
  },
  {
    "Product document image": "صورة وثيقة المنتج",
    "Additional document images": "صور إضافية للوثيقة",
    "Solutions product documents": "وثائق منتجات الحلول",
    "Related product documents": "وثائق منتجات ذات صلة",
  },
);

export function getArabicProductDocumentMeta(slug) {
  return productDocumentArabicBySlug[slug] || null;
}
